const selectStyles = {
    container: styles => ({
        ...styles,
        '> span + div': {
            borderColor: '#3dbbe2', boxShadow: '0 0 0 1px #3dbbe2'
        }
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    control: (styles, state) => ({
        ...styles,
        minHeight: 40,
        paddingTop: 1,
        cursor: 'pointer',
        borderColor: (state.selectProps['data-error'] ? '#f44336!important' : '#ced4da'),
        '&:hover': {
            borderColor: '#3dbbe2'
        }
    }),
    option: (styles, state) => ({
        ...styles,
        backgroundColor: state.isSelected ? '#3dbbe2' : '#fff',
        ...(state.data.archived && state.data.archived == 't' ? {textDecoration: 'line-through'} : {}),
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#3dbbe2', color: '#fff'
        }
    }),
    singleValue: (styles, state) => ({
        ...styles,
        ...(state.data.archived && state.data.archived == 't' ? {textDecoration: 'line-through'} : {}),
    }),
    multiValue: (styles, state) => ({
        ...styles,
        ...(state.data.archived && state.data.archived == 't' ? {textDecoration: 'line-through'} : {}),
    }),
    menu: styles => ({
        ...styles,
        zIndex: 2,
    }),
    placeholder: styles => ({
        ...styles,
        color: '#ccc',
    }),
};

export default selectStyles;